import React from 'react'
import styles from './AdvtFullSize.module.css'
import cn from 'classnames'
import { iconsSources } from '../../helpers/icons'
import { useGetParams } from '../../hooks/useGetParams'
import { formatPhoneNumber } from '../../helpers/titreHelper'

const AdvtFullSize = React.memo(({ className, advtInfo }) => {
  const { paddingQR, sizeQR, titleFontSize, phoneNumberFontSize } =
    useGetParams()

  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, ' ')

  return (
    <div className={cn(className)}>
      <div className={styles.wrapper}>
        {(advtInfo.qrCode1 || advtInfo.qrCode2) && (
          <div className={styles.qrsWrapper}>
            {advtInfo.qrCode1 && (
              <div
                className={styles.qrItem}
                style={{
                  width: `${sizeQR}rem`,
                  height: `${sizeQR}rem`,
                  padding: `${paddingQR}rem`,
                }}
              >
                <img src={advtInfo.qrCode1} alt="qrCode1" />
              </div>
            )}
            {advtInfo.qrCode2 && (
              <div
                className={styles.qrItem}
                style={{
                  width: `${sizeQR}rem`,
                  height: `${sizeQR}rem`,
                  padding: `${paddingQR}rem`,
                }}
              >
                <img src={advtInfo.qrCode2} alt="qrCode2" />
              </div>
            )}
          </div>
        )}

        <div className={styles.advtInfo}>
          {advtInfo.advtImage && (
            <div
              style={{ maxWidth: `${advtInfo.advtImageSize}rem` }}
              className={styles.advtImageContainer}
            >
              <img src={advtInfo.advtImage} alt="" />
            </div>
          )}

          {advtInfo.label && (
            <div
              className={styles.title}
              style={{ fontSize: `${titleFontSize}rem` }}
            >
              {advtInfo.label}
            </div>
          )}

          <div className={styles.phoneAndSocial}>
            {phoneNumberFormat && (
              <div
                className={styles.number}
                style={{ fontSize: `${phoneNumberFontSize}rem` }}
              >
                {phoneNumberFormat}
              </div>
            )}

            {Boolean(advtInfo.socials?.length) && (
              <div className={styles.socials}>
                {advtInfo.socials?.map((item) => (
                  <div key={item} className={styles.icon}>
                    <img src={iconsSources[item]} alt="social" />
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
})

export default AdvtFullSize
